import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const KEY = "labor_cookie_ack_v1";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setShow(true);
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, new Date().toISOString());
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t-2 border-labor-olive shadow-2xl"
    >
      <div className="max-w-5xl mx-auto px-4 py-3 sm:py-4 flex flex-col sm:flex-row gap-3 items-start sm:items-center">
        <Cookie className="w-6 h-6 text-labor-olive flex-shrink-0 hidden sm:block" />
        <div className="text-xs sm:text-sm text-labor-ink flex-1 leading-relaxed">
          Usiamo solo cookie <strong>tecnici essenziali</strong> (sessione, login sicuro). <strong>Nessun tracciamento</strong> e nessun cookie pubblicitario.
          Continuando a navigare accetti l'uso di questi cookie. Leggi la nostra{" "}
          <Link to="/privacy-policy" className="text-labor-olive underline">Privacy Policy</Link>.
        </div>
        <button
          data-testid="cookie-accept"
          onClick={accept}
          className="olive-btn px-5 py-2 text-sm font-semibold whitespace-nowrap"
        >
          Ho capito
        </button>
        <button
          data-testid="cookie-close"
          onClick={accept}
          aria-label="Chiudi"
          className="text-labor-muted hover:text-labor-ink absolute top-2 right-2 sm:static"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
